// extracted by mini-css-extract-plugin
export default {"button":"ButtonEdge_button__uLMeo"};